<template>
  <div>
    <!-- Progress bar during route transitions: without it, heavy pages (e.g. the catalog)
         leave the previous page frozen on screen with no feedback while they mount (#22). -->
    <NuxtLoadingIndicator color="#009d66" :height="3" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
import '@/assets/css/tailwind.css'
import '@/assets/css/dark.css'
import 'shepherd.js/dist/css/shepherd.css'


import { useI18n } from "vue-i18n";
import { useAttributeStore } from "./store/AttributeStore";
import { useCategoryStore } from "./store/CategoryStore";
import { useUserStore } from "./store/UserStore";
import { useUtilityStore } from "./store/UtililityStore";
import { useCmsStore } from "./store/cms/cmsStore";

const userStore = useUserStore();
const attributeStore = useAttributeStore();
const utilityStore = useUtilityStore();
const categoryStore = useCategoryStore();

const cmdStore = useCmsStore();

const { availableLocales } = useI18n();



onBeforeMount(() => {
  userStore.setIsAuthenticated();

  categoryStore.getCategoriesPromo();
  // onMounted(() => {
  let languageInStorage = localStorage?.getItem("selectedLanguage");
  if (languageInStorage) {
    const { value } = JSON.parse(languageInStorage)
    languageInStorage = value || "en";
  }
  const userLanguage = (languageInStorage || window?.navigator?.language).split("-")[0];
  if (availableLocales.includes(userLanguage)) {
    // const _lng = languageMap.value[userLanguage];
    utilityStore.setLanguage(userLanguage);
  } else {
    utilityStore.setLanguage("en");
  }

  // });

})

onMounted(() => {
  setTimeout(() => {
    attributeStore.getAttributes();
    cmdStore.getCmsDocuments().then(() => {
      // console.log("CMS Documents Loaded", cmdStore.legalDocuments);
    }).catch((error) => {
      console.error("Error loading CMS documents:", error);
    });
  }, 2000);
});



</script>
